module.exports = __webpack_public_path__ + "img/flag_israel2.fd256d3b.svg";